// ----
// SCM.SharedControls.PDFAccess.js
// checks a user's access to a PDF and launches the PDF or a no-access modal
//
// The PDF links, located in multiple widgets, contain HTML 5 attributes like data-article-id, data-article-url, data-ajax-url, data-issue-id ...
// In ToolboxPdf.cshtml, the article PDF link is identified by classes al-link and pdfaccess; the issue PDF link is identified by classes al-link and issue-pdfLink
//
// The noAccessReveal modal is in Site.Master in the client project; it is used for both the article and issue PDF "no access" modals
// In the noAccessReveal modal, the article purchase link has id=articleLinkToPurchase, the issue purchase modal has class=issue-purchase-modal
//
// There are 2 kinds of Issue PDFs: TOC.pdf (available to anyone) and fullissue.pdf (only authenticated users may access)
// ----

var SCM = SCM || {};

(function (pdf, $) {
    // ----
    // Private variables and functions
    // ----
    function formatIssuePurchaseLink(issuePurchaseUrl, id) {
        // If the purchase URL contains "resourceid=", format the "resourceid=" portion of the querystring with the current issue id
        var revisedIssuePurchaseUrl = issuePurchaseUrl;

        if (issuePurchaseUrl.toLowerCase().indexOf('resourceid=') >= 0) {
            var pattern = /resourceID=\{0\}|resourceID=\d+/i;
            revisedIssuePurchaseUrl = issuePurchaseUrl.replace(pattern, 'resourceid=' + id);
        }

        return revisedIssuePurchaseUrl;
    }

    function logErrors(jqXHR, textStatus, errorThrown) {
        if (window.console) {
            var err = eval('(' + jqXHR.responseText + ')');
            console.error('error: ' + err);
            console.error('status: ' + textStatus);
        }
    }

    function openPDF(PDFUrl) {
        window.location.href = PDFUrl;
    }

    function openNoAccessModalArticle(articlePdfAnchor, articldeID) {
        // remove data attributes so ajax call doesn't happen if PDF link is clicked a 2nd time.
        // instead, link the PDF link directly with the No-Access modal
        articlePdfAnchor.attr({ 'data-reveal-id': 'noAccessReveal', 'data-reveal': '' }).removeAttr('data-ajax-url');
        var articleUrl = '/article.aspx?articleid=' + articldeID + '#purchaseSubscriptionBox';
        pdf.$noAccessModal.find('#articleLinkToPurchase').attr('href', articleUrl);
        SCM.Utilities.Reveal.open(pdf.$noAccessModal);
    }

    function openNoAccessModalArticleSeo(articlePdfAnchor, articldeID, seoUrl) {
        // remove data attributes so ajax call doesn't happen if PDF link is clicked a 2nd time.
        // instead, link the PDF link directly with the No-Access modal
        articlePdfAnchor.attr({ 'data-reveal-id': 'noAccessReveal', 'data-reveal': '' }).removeAttr('data-ajax-url');
        if (seoUrl === 'DO_NOT_USE') {
            pdf.$noAccessModal.find('#articleLinkToPurchase').remove();
        } else {
            var articleUrl = seoUrl;
            pdf.$noAccessModal.find('#articleLinkToPurchase').attr('href', articleUrl);
        }
        SCM.Utilities.Reveal.open(pdf.$noAccessModal);
    }

    // ----
    // Public variables and methods
    // ----

    // making modal selector public so it can be overriden in the client implementation
    pdf.$noAccessModal = $('#noAccessReveal');

    pdf.checkArticlePDFAccess = function (articlePdfAnchor) {
        var id = articlePdfAnchor.attr('data-article-id'),
            url = articlePdfAnchor.attr('data-article-url'),
            ajaxUrl = articlePdfAnchor.attr('data-ajax-url'),
            baseSiteUrl = $('#hfSiteURL');
        var seoUrl = '';
        if (articlePdfAnchor.attr('data-article-seo-url') !== null) {
            seoUrl = articlePdfAnchor.attr('data-article-seo-url');
        }
        if (typeof baseSiteUrl !== 'undefined' && typeof baseSiteUrl.val() !== 'undefined' && baseSiteUrl !== '') {
            ajaxUrl = '//' + baseSiteUrl.val() + ajaxUrl;
        }


        //set up data object to send...
        var name1 = 'aId';
        var value1 = id;
        var dataObj = {};
        dataObj[name1] = value1;


        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            data: dataObj,
            traditional: true,
            success: function (access) {
                if (access.Success) {
                    openPDF(url);
                } else {
                    if (seoUrl.length > 0) {
                        openNoAccessModalArticleSeo(articlePdfAnchor, id, seoUrl);
                    } else {
                        openNoAccessModalArticle(articlePdfAnchor, id);
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                logErrors(jqXHR, textStatus, errorThrown);
            }
        });
    };


    pdf.checkIssuePDFAccess = function ($issuePdfAnchor) {
        if ($issuePdfAnchor.length) {
            var id = $issuePdfAnchor.attr('data-issue-id'),
                ajaxUrl = $issuePdfAnchor.attr('data-ajax-issue-url');

            $.ajax({
                type: 'POST',
                url: ajaxUrl,
                data: { issueId: id },
                traditional: true,
                //global:false is used to prevent an infinite loop in ajax.complete
                //https://stackoverflow.com/questions/52634935/preventing-a-loop-inside-ajax-complete
                global: false,
                success: function (access) {
                    if (access.Success) {
                        $issuePdfAnchor.addClass('visible');
                    } else {
                        $issuePdfAnchor.addClass('hide');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $issuePdfAnchor.addClass('hide');
                }
            });
        }
    };

    pdf.checkIssuePDFAccessModalOnClick = function ($issuePdfAnchor) {
        if ($issuePdfAnchor.length) {
            var multimediaId = $issuePdfAnchor.data('multimediaId');
            var pdfHandlerUrl = $issuePdfAnchor.data('pdfHandlerUrl');

            SCM.Ajax.post(
                '/pdf/CheckIssuePdfAccessWithMessaging',
                {
                    'multimediaId': multimediaId,
                    'pdfHandlerUrl': pdfHandlerUrl
                })
                .expectJson()
                .then(result => {
                    if (!result.Success) {
                        throw result?.ErrorMessage ?? 'The PDF for this issue cannot be found'
                    }
                    if (!result.AccessGranted) {
                        throw result?.AccessDeniedMessage ?? 'Access Denied';
                    }
                    return result;
                })
                .then(result => {
                    window.open(result.PdfHandlerUrl);
                })
                .catch(reason => {
                    var message = reason?.result?.ErrorMessage
                        ? reason.result.ErrorMessage
                        : reason;
                    SCM.Modals.showModal(message);
                });
        }
    }


    pdf.ipCountryAccessCheck = function ($ipCountyPdfAnchor) {
        if (!$ipCountyPdfAnchor.length) {
            return;
        }
        $ipCountyPdfAnchor.off().on('click', function (e) {
            e.preventDefault();
            var resourceId = $(this).data('resourceid');
            var resourceTypeId = $(this).data('resourcetypeid');
            SCM.Ajax.post('/Pdf/PdfByIpCountry/ipCountryCheck', { resourceId: resourceId, resourceTypeId: resourceTypeId })
                .expectJson()
                .then(function (result) {
                    if (result.Success) {
                        $(e.currentTarget).unbind('click');
                        e.currentTarget.click();
                    } else {
                        pdf.$noAccessModal.find('#noAccessForm').html(result.Messages[0]);
                        SCM.Utilities.Reveal.open(pdf.$noAccessModal);
                    }
                })
                .catch(function (reason) {
                    console.error('Failed to check IP Country based access: ' + reason);
                });
        });
    }

    pdf.bindUiEvents = function () {
        $(document).off('click.scm-pdfaccess');

        // Article PDFs
        $(document).on('click.scm-pdfaccess', '.al-link.pdfaccess', function () {
            SCM.Utilities.Reveal.close(pdf.$noAccessModal);
            pdf.$noAccessModal.find('#articleLinkToPurchase').show();
            pdf.$noAccessModal.find('.issue-purchase-modal').hide();

            if (!$(this).attr('data-reveal-id')) {
                pdf.checkArticlePDFAccess($(this));
            }
        });

        //issue onclick pdfs
        $(document).on('click.scm-pdfaccess', '.js-issue-pdfLink-check', function () {
            pdf.checkIssuePDFAccessModalOnClick($(this));
        });

        pdf.checkIssuePDFAccess($('.js-issue-pdfLink'));
        pdf.ipCountryAccessCheck($('.js-pdfByIpCountry'));
    };

    pdf.init = function () {
        pdf.bindUiEvents();
    };

})(SCM.PDFAccess = SCM.PDFAccess || {}, jQuery);